<template>
    <el-select v-model="selectedValue" clearable placeholder="请选择专属链接" style="width:150px;"  @change="$emit('selectedValue',selectedValue)">
        <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.linkName"
                :value="item.id">
        </el-option>
    </el-select>
</template>

<script>
    import usedCarModel  from '@/framework/models/usedCarModel'
    export default {
        name: "usedCarSingleSelect",
        data() {
            return {
                options: [],
                selectedValue: null,
            }
        },
        props:['channelId']

       ,
        created: function(){
            this.findUsedCarSingleInfoKv(this.channelId)
        },
        methods:{
            findUsedCarSingleInfoKv: function(channelId) {

                let that = this
                let params = {
                    channelId: channelId
                }

                let listener = {
                    success: function(dataInfo) {

                        that.options = dataInfo.datas

                    }
                }
                usedCarModel.findUsedCarSingleInfoKv(that,params, listener)
            }

        }

    }
</script>

<style scoped>

</style>
